import React, { useEffect, useState } from "react";

export default function PropertyData(props: any) {
  return (
    <div className="p-16 border rounded-lg">
      {props.data
        ? Object.keys(props.data.property_dump).map((key) => (
            <p key={key}>
              {key}: {JSON.stringify(props.data.property_dump[key])}
            </p>
          ))
        : "no event data"}
    </div>
  );
}
